<template>
    <button
        type="button"
        class="flex items-center justify-center border border-blue-500 text-blue-500 rounded-lg h-9 px-4 space-x-2 hover:bg-gray-50"
        @click="$emit('action-button-click')"
    >
        <div class="text-sm font-medium">
            <slot/>
        </div>
        <SvgIcon :icon="icon" size="sm" weight="bold"/>
    </button>
</template>

<script lang="ts">
export default {
    props: {
        icon: String,
    },
};
</script>
